import { CustomBarMode } from '../../@const/sidebarMenu';
//여닫기
const TOGGLE_CUSTOMBAR = 'accessBar/TOGGLE_CUSTOMBAR' as const;
//모드 설정
const SET_CUSTOMBAR_MODE = 'accessBar/SET_CUSTOMBAR_MODE' as const;
//열기/닫기 매개변수로
const SET_CUSTOMBAR_OPEN = 'accessBar/SET_CUSTOMBAR_OPEN' as const;

export type CustombarAction =
  | {
      type: typeof TOGGLE_CUSTOMBAR;
    }
  | {
      type: typeof SET_CUSTOMBAR_MODE;
      payload: CustomBarMode;
    }
  | {
      type: typeof SET_CUSTOMBAR_OPEN;
      payload: boolean;
    };

export interface CustombarState {
  open: boolean;
  mode: CustomBarMode;
}

export const toggleCustombar = () => ({
  type: TOGGLE_CUSTOMBAR,
});

export const setCustombarMode = (payload: CustomBarMode) => ({
  type: SET_CUSTOMBAR_MODE,
  payload: payload,
});

export const setCustombarOpen = (payload: boolean) => ({
  type: SET_CUSTOMBAR_OPEN,
  payload: payload,
});

const initialState: CustombarState = {
  open: false,
  mode: 'BOARD',
};

const custombarReducer = (
  state: CustombarState = initialState,
  action: CustombarAction
) => {
  switch (action.type) {
    case TOGGLE_CUSTOMBAR:
      return {
        ...state,
        open: !state.open,
      };
    case SET_CUSTOMBAR_MODE:
      return {
        ...state,
        mode: action.payload,
      };
    case SET_CUSTOMBAR_OPEN:
      return {
        ...state,
        open: action.payload,
      };

    default:
      return state;
  }
};

export default custombarReducer;
